export default __webpack_public_path__ + "static/registration-ba3868f220adfc8e81ad1c6b80e35569.png";